<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :modal="false"
    :title="$t('SeaExport.FileUpload')"
    width="670px"
    :close-on-click-modal="false"
    :class="'app-main-inner'+(uploading?' not-click':'')"
    :append-to-body="true"
  >
    <div class="app-main-inner-row row-grid" style="display:flex;min-height:350px;padding:0">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%"
        class="upload-table"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <span slot="footer" style="padding-right:30px">
      <el-upload
        action
        multiple
        :auto-upload="false"
        :show-file-list="false"
        :on-change="toChooseFile"
        style="float:left;margin-left:30px;margin-right:5px"
        no="1"
      >
        <el-button type="primary">{{ $t('SeaExport.SelectFile') }}</el-button>
      </el-upload>
      <el-button type="danger" style="float:left" no="3" @click="remove()">{{ $t('SeaExport.DeleteFile') }}</el-button>
      <el-button type="primary" no="4" @click="upload()">{{ $t('SeaExport.Upload') }}</el-button>
      <el-button no="5" @click="innerVisible=false">{{ $t('SeaExport.Close') }}</el-button>
    </span>
    <!-- 文档类别弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="docTypeTree.visible"
      :title="$t('SeaExport.Edit')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="docTypeTree.gridOptions"
          :row-data="docTypeTree.rowData"
          style="width:350px;height:300px;padding-left:2px"
          @gridReady="params=>docTypeTree.gridApi=params.api"
        />
      </div>
      <span slot="footer" style="padding-right:30px">
        <el-button type="primary" no="6" @click="saveDocType()">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="7" @click="docTypeTree.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { batchUploadFileForJob } from '@/api/seaExport/seaExportJob'
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'

export default {
  name: 'BatchUploadFile',
  props: {
    visible: { type: Boolean, required: true },
    redisKey: { type: String, required: true },
    lob: { type: String, default: '' },
    jobNum: { type: Number, default: 1 },
    pageSource: { type: String, default: '' },
    otherUploadFunc: { type: Function, required: false, default: null } // 其他上传事件
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.FileName'),
          colId: 'fileName',
          field: 'fileName',
          width: 175,
          cellRenderer: params => {
            if (params.data.fileId) {
              return `<a href="${URL.common.findByFileId}/${
                params.data.fileId
              }?sessionId=${
                this.user.sessionId
              }" target="_blank" style="color:blue">${params.value}</a>`
            } else {
              return params.value
            }
          }
        },
        {
          headerName: this.$t('SeaExport.FileType'),
          colId: 'fileType',
          field: 'fileType',
          width: 115
        },
        {
          headerName: this.$t('SeaExport.FileSize'),
          colId: 'fileSize',
          field: 'fileSize',
          width: 115,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(2) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('SeaExport.UploadProgress'),
          colId: 'uploadProgress',
          field: 'uploadProgress',
          width: 115,
          cellRenderer: params => {
            if (params.data && params.data.uploadProgress) {
              return params.data.uploadProgress
            } else if (params.data && params.data.duplicate && params.data.duplicate === 1) {
              return this.$t('CargoMsg.Cargo_UploadedRepeatedly')
            } else {
              if (params.value) {
                return `<span style="color:green">${this.$t('Message.Uploaded')}</span>`
              }
              if (this.uploading) {
                return this.$t('queryJob.uploading') + '...'
              }
              return this.$t('Message.Waiting')
            }
          },
          tooltipValueGetter: (params) => {
            if (params.data && params.value) {
              return params.value
            }
          }
        },
        {
          headerName: this.$t('SeaExport.DocumentType'),
          colId: 'fileCategoryLabel',
          field: 'fileCategoryLabel',
          width: 115,
          cellRenderer: params => {
            if (params.data.fileId) {
              return params.value
            } else {
              const methodPath = this.documentManage.getPath('showDocTypeTree')
              return `<div onclick="${methodPath}(${
                params.data.seq
              })" style="cursor:pointer">${params.value || '&nbsp;'}</div>`
            }
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      docTypeTree: {
        visible: false,
        isBatchSave: false, // 是否批量保存
        gridOptions: {
          // 自行实现多选
          // rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  let borderColor = '#999999'
                  let iconColor = 'transparent'
                  if (params.data.checked) {
                    borderColor = '#1F75D5'
                    iconColor = '#1F75D5'
                  }
                  return `<i class="el-icon-check" style="height:1.3em;width:1.3em;border:1.5px solid ${borderColor};border-radius:0.65em;line-height:1.3em;vertical-align:text-bottom;background:white;color:${iconColor};font-size:12px;"></i>
                          &nbsp;${this.isZh ? params.data.chineseName : params.data.englishName}`
                }
                return this.isZh ? params.data.chineseName : params.data.englishName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      fileTypes: ['PNG', 'JPG', 'JPEG', 'GIF', 'TIF', 'TIFF', 'DOC',
        'DOCX', 'XLS', 'XLSX', 'PDF', 'RTF', 'TXT', 'RAR', 'ZIP', 'EML', 'XML', 'MSG', 'JSON', 'YAML'],
      docTypeMap: new Map(),
      uploading: false,
      loading: null,
      selectedNode: null,
      batchUploading: false // 批量上传校验上传中
    }
  },
  computed: {
    finalLob() {
      return this.lob
    },
    selectedFile() {
      return this.selectedNode ? this.selectedNode.data : null
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.$emit('uploadDone', this.rowData)
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    },
    finalLob(newVal) {
      this.buildDocTypeTree()
    }
  },
  async created() {
    await this.buildDocTypeTree()
    if (this.visible) {
      this.innerVisible = true
      await this.initData()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showDocTypeTree', function(seq) {
      context.showDocTypeTree(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
    },
    async buildDocTypeTree() {
      if (this.finalLob) {
        getDocCategoryTypeTreeByLob({
          constructLobParent: false,
          lob: this.finalLob
        }).then(res => {
          const data = res.data.filter(p => {
            const pathArr = p.path.split(',')
            if (p.type === 1) {
              return pathArr.length === 1
            }
            if (p.type === 2) {
              return pathArr.length > 1
            }
            return false
          })
          data.forEach(item => {
            item.checked = false
            if (item.type === 2) {
              this.docTypeMap.set(item.code.toUpperCase(), this.isZh ? item.chineseName : item.englishName)
            }
          })
          this.docTypeTree.rowData = data
        })
      } else {
        this.docTypeTree.rowData = []
      }
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.N1Exceeds20MBCannotUploaded'))
        return
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      if (!fileType || !this.fileTypes.includes(fileType.toUpperCase())) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BatchUploadFile2'))
        return
      }
      const params = { file: file.raw }
      params.createdBy = this.user.userId
      params.createChineseName = this.user.chineseName
      params.createEnglishName = this.user.englishName
      this.rowData.push({
        seq: this.autoIncrementNum.getNextNum(),
        fileId: '',
        fileName,
        fileType,
        fileSize: file.size,
        fileCategory: '',
        fileCategoryLabel: '',
        params
      })
    },
    showDocTypeTree(seq) {
      const rows = this.rowData.filter(p => p.seq === seq)
      if (rows.length === 0) {
        return
      }
      const fileCategory = rows[0].fileCategory.toUpperCase()
      const fileCategories = fileCategory ? fileCategory.split(',') : []
      this.docTypeTree.rowData.forEach(item => {
        if (fileCategories.length > 0 && fileCategories.includes(item.code.toUpperCase())) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.docTypeTree.rowData = [...this.docTypeTree.rowData]
      this.docTypeTree.isBatchSave = false
      this.docTypeTree.visible = true
    },
    saveDocType() {
      const docTypeRows = this.docTypeTree.rowData.filter(
        p => p.type === 2 && p.checked
      )
      let fileCategory = ''
      let fileCategoryLabel = ''
      let documentTypeUuid = ''
      if (docTypeRows.length > 0) {
        let codes = ''
        let labels = ''
        let keys = ''
        for (const item of docTypeRows) {
          if (codes) {
            codes += ','
          }
          codes += item.code
          if (labels) {
            labels += ','
          }
          labels += (this.isZh ? item.chineseName : item.englishName)
          if (keys) {
            keys += ','
          }
          keys += item.uuid
        }
        fileCategory = codes
        fileCategoryLabel = labels
        documentTypeUuid = keys
      } else {
        fileCategory = ''
        fileCategoryLabel = ''
        documentTypeUuid = ''
      }
      if (this.docTypeTree.isBatchSave) {
        const rows = this.gridApi.getSelectedRows()
        for (const row of rows) {
          row.fileCategory = fileCategory
          row.fileCategoryLabel = fileCategoryLabel
          row.documentTypeUuid = documentTypeUuid
        }
      } else {
        if (this.selectedFile) {
          this.selectedFile.fileCategory = fileCategory
          this.selectedFile.fileCategoryLabel = fileCategoryLabel
          this.selectedFile.documentTypeUuid = documentTypeUuid
        }
      }
      this.gridApi.refreshCells({ force: true })
      this.docTypeTree.visible = false
    },
    remove() {
      if (!this.selectedFile) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      this.$confirm(
        this.$t('common.tips.confirmDelete'),
        this.$t('common.tips.prompt'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }
      )
        .then(async() => {
          const row = this.selectedFile
          this.rowData = this.rowData.filter(p => p.seq !== row.seq)
        })
        .catch(() => {})
    },
    upload() {
      if (this.otherUploadFunc) {
        this.otherUploadFunc(this.uploadFunc)
      } else {
        this.uploadFunc()
      }
    },
    async uploadFunc() {
      this.batchUploading = false
      const rows = this.rowData.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      this.loading = getLoading('upload-table')
      this.uploading = true
      this.gridApi.refreshCells({ force: true })
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p.params
            if (!params.hasOwnProperty('documentType')) {
              params.documentType = p.fileCategory || 'OTHER'
            }
            params.documentName = p.fileCategoryLabel || 'OTHER'
            params.isShared = 'false'
            params.op = 'false'
            params.sales = 'false'
            params.cargoSales = 'false'
            params.csr = 'false'
            params.overseaOp = 'false'
            params.dc = 'false'
            params.planner = 'false'
            params.all = 'false'
            params.customer = 'false'
            params.consignee = 'false'
            params.shipper = 'false'
            params.destinationAgent = 'false'
            params.b2bCustomer = 'false'
            params.b2bDesignationAgent = 'false'
            params.b2bDestinationAgent = 'false'
            params.b2bConsignee = 'false'
            params.bookingAgent = 'false'
            params.pageSource = this.pageSource
            params.language = this.isZh
            params.asyncDo = (this.jobNum > 50) // 判断是否要异步处理
            params.redisKey = this.redisKey // 这里把文件关联的redisKey传过去
            params.branchId = this.$store.getters.currentOfficeId
            params.fileSource = ChargeItemTarget.UPLOAD.code
            return batchUploadFileForJob(params).then(res => {
              p.success = res.data.success
              p.fileCategory = params.documentType
              p.fileCategoryLabel = params.documentName
              p.uploadProgress = this.$t('Message.UploadSuccessful')
            }).catch((e) => {
              p.uploadProgress = e
            })
          })
        )
      } catch {
        const uploadSuccessCount = rows.filter(p => p.success).length
        const uploadFailCount = rows.filter(p => !p.success).length
        await this.$confirm(
          this.$t('queryJob.Upload0UploadFailed0', [uploadSuccessCount, uploadFailCount]),
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      } finally {
        this.loading.close()
        this.uploading = false
        // 异步上传提示
        if (this.jobNum > 50) {
          await this.$confirm(
            this.$t('CargoMsg.Cargo_UploadFileOver50'),
            this.$t('common.tips.prompt'),
            {
              showClose: false,
              confirmButtonText: this.$t('common.btn.ok'),
              showCancelButton: false,
              type: 'warning'
            }
          )
        } else {
          this.$message.success(this.$t('SeaExport.UploadSuccess'))
        }
        this.innerVisible = false
        this.gridApi.refreshCells({ force: true })
      }
    }
  }
}
</script>
